export default __webpack_public_path__ + "static/media/yandex-ru.729ec24f.svg";